module.exports = __webpack_public_path__ + "img/expand-recommend.56590f1e.svg";